"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
/**
 * Click outside behavior
 */
var ClickOutside = /** @class */ (function (_super) {
    tslib_1.__extends(ClickOutside, _super);
    function ClickOutside(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Check whether the click is inside the element or excluded
         * @param event - Click event
         */
        _this._isInsideClick = function (event) {
            var _a = _this.props, rootRef = _a.rootRef, excludeClass = _a.excludeClass;
            var target = event.target;
            while (target) {
                if (rootRef.current === target ||
                    (target.classList && target.classList.contains(excludeClass))) {
                    return true;
                }
                target = target.parentElement;
            }
        };
        /**
         * Triggers onClickOutside callback when clicked outside child
         * @param event - Click event
         */
        _this._onClickOutside = function (event) {
            var onClickOutside = _this.props.onClickOutside;
            if (!_this._isInsideClick(event)) {
                onClickOutside(event);
            }
        };
        _this._boundEvents = [];
        return _this;
    }
    /**
     * Register ClickOutside events
     */
    ClickOutside.prototype._registerEvents = function () {
        var _this = this;
        var options = this.props.options;
        ['mouseup', 'touchend'].forEach(function (eventName) {
            document.addEventListener(eventName, _this._onClickOutside, options);
            _this._boundEvents.push(eventName);
        });
    };
    /**
     * Unregister ClickOutside events
     */
    ClickOutside.prototype._unregisterEvents = function () {
        var options = this.props.options;
        while (this._boundEvents.length > 0) {
            var eventName = this._boundEvents.pop();
            document.removeEventListener(eventName, this._onClickOutside, options);
        }
    };
    ClickOutside.prototype.componentDidMount = function () {
        if (this.props.onClickOutside) {
            this._registerEvents();
        }
    };
    ClickOutside.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.onClickOutside !== prevProps.onClickOutside) {
            if (this.props.onClickOutside) {
                this._registerEvents();
            }
            else {
                this._unregisterEvents();
            }
        }
    };
    ClickOutside.prototype.componentWillUnmount = function () {
        this._unregisterEvents();
    };
    ClickOutside.prototype.render = function () {
        return this.props.children;
    };
    return ClickOutside;
}(React.PureComponent));
exports.ClickOutside = ClickOutside;
//# sourceMappingURL=ClickOutside.js.map